import { render, staticRenderFns } from "./ConnectWalletBox.vue?vue&type=template&id=329d1bf0"
import script from "./ConnectWalletBox.vue?vue&type=script&lang=js"
export * from "./ConnectWalletBox.vue?vue&type=script&lang=js"
import style0 from "./ConnectWalletBox.vue?vue&type=style&index=0&id=329d1bf0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports